import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { combineLatest } from 'rxjs/internal/observable/combineLatest';
import { map } from 'rxjs/operators';
import Swal, { SweetAlertResult } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private translate: TranslateService) { }

  info(title: string, text: string, button: string): Promise<SweetAlertResult> {
    return Swal.fire({
      title: title,
      text: text,
      type: 'info',
      confirmButtonText: button
    });
  }

  success(title: string, text: string, button: string): Promise<SweetAlertResult> {
    return Swal.fire({
      title: title,
      text: text,
      type: 'success',
      confirmButtonText: button
    });
  }

  warning(title: string, text: string, button: string): Promise<SweetAlertResult> {
    return Swal.fire({
      title: title,
      text: text,
      type: 'warning',
      confirmButtonText: button
    });
  }

  error(title: string, text: string, button: string): Promise<SweetAlertResult> {
    return Swal.fire({
      title: title,
      text: text,
      type: 'error',
      confirmButtonText: button
    });
  }

  question(title: string, text: string, button: string): Promise<SweetAlertResult> {
    return Swal.fire({
      title: title,
      text: text,
      type: 'question',
      confirmButtonText: button
    });
  }

  infoWithTranslate(title: string, text: string, paramsForTitle?: Object, paramsForText?: Object): Promise<SweetAlertResult> {
    return this.getProperties(title, text, this.info, paramsForText).toPromise();
  }

  successWithTranslate(title: string, text: string, paramsForTitle?: Object, paramsForText?: Object): Promise<SweetAlertResult> {
    return this.getProperties(title, text, this.success, paramsForText).toPromise();
  }

  warningWithTranslate(title: string, text: string, paramsForTitle?: Object, paramsForText?: Object): Promise<SweetAlertResult> {
    return this.getProperties(title, text, this.warning, paramsForText).toPromise();
  }

  errorWithTranslate(title: string, text: string, paramsForTitle?: Object, paramsForText?: Object): Promise<SweetAlertResult> {
    return this.getProperties(title, text, this.error, paramsForText).toPromise();
  }

  questionWithTranslate(title: string, text: string, paramsForTitle?: Object, paramsForText?: Object): Promise<SweetAlertResult> {
    return this.getProperties(title, text, this.question, paramsForText).toPromise();
  }

  private getProperties(title: string, text: string, fnSwal: Function, paramsForTitle?: Object, paramsForText?: Object): Observable<any> {
    return combineLatest(
      this.translate.get(title, paramsForTitle),
      this.translate.get(text, paramsForText),
      this.translate.get('button.ok'),
    ).pipe(
      map(([_title, _text, _btn]) => {
        // combineLatest returns an array of values, here we map those values to an object
        return fnSwal(_title, _text, _btn);
      })
    );
  }
}
